var $ = require('jquery')

angular.module('blc').controller('FooterCtrl', FooterCtrl);
FooterCtrl.$inject = ['$scope', 'xlat_service', 'currency_srv'];
function FooterCtrl($scope, xlat_service, currency_srv) {
  $scope.language = xlat_service.get_lang();
  $scope.currency_code = currency_srv.get_currency().code;


  $scope.$watch('currency_code', function(curr, prev) {
    if (curr==prev) return;
    currency_srv.set_currency(curr);
  });

  $scope.$watch('language', function(curr, prev) {
    if (curr==prev) return;
    xlat_service.set_lang(curr);
    $('#same-search').focus();  
  });
}




/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/footer-ctrl.js
 ** module id = 25
 ** module chunks = 0
 **/